/**
 * Time and materials billed from the job (pieces 22 and 29; decisions 2591 to
 * 2594): the order path's refusal, the job's invoice lines, the parts refusal,
 * the customer PO amount and its warning. Spread into the one lookup in
 * `strings.ts`, so `t()` stays the only way a screen reads text. 🔨 This file
 * imports nothing.
 */
export const JOB_BILLING_STRINGS = {
  // Decision 2591: the order's invoice path refuses a time and materials service line by name.
  'jobBilling.order.refusal': 'Time and materials bills from the job, never from the Sales Order: {lines}. Raise the invoice from the Work Order.',
  'jobBilling.order.refusalLine': 'line {line}, {description}, bills from {job}',
  'jobBilling.order.noJobYet': 'its Work Order once one is raised',
  'jobBilling.order.billsFromJob': 'bills from its Work Order',
  'jobBilling.order.billedFromJob': 'invoiced from its Work Order',
  // Decision 2592: the minimum topped up on a visit short of it, portal to portal.
  'jobBilling.minimumLine': 'Minimum charge top-up',
  // T1900: the line's priority and after-hours premium bills as a line of its own beneath each worker's hours.
  'jobBilling.premium.priority': 'Priority premium',
  'jobBilling.premium.afterHours': 'After-hours premium',
  'jobBilling.premium.both': 'Priority and after-hours premium',
  // Decision 2593: a fitted part with no sell price refuses the invoice by name.
  'jobBilling.parts.noSellPrice': 'These parts carry no sell price, so the invoice is not written: {parts}. Set each part’s sales price on its Item, then raise the invoice again.',
  // Decision 2594 (T1003, T1171): Raise an Invoice on a finished job.
  'jobBilling.raiseInvoice': 'Raise an Invoice',
  // Decision 2594 (T1175): the customer PO amount on the Sales Order, and the warning past it.
  'jobBilling.po.amount': 'Customer PO amount',
  'jobBilling.po.amountHint': 'The amount the customer’s purchase order covers. Work and invoices past it are warned about, never refused.',
  'jobBilling.po.setAmount': 'Customer PO Amount',
  'jobBilling.po.amountTitle': 'Customer PO Amount',
  'jobBilling.po.amountSaved': 'Customer PO amount saved.',
  'jobBilling.po.noNumber': '(no number yet)',
  'jobBilling.po.invoiceWarning': 'Billed against customer PO {number}, this invoice included, comes to {toDate}: {over} past its amount of {amount}. Issue still goes through; get a revised PO or the customer’s sign-off first.',
  'jobBilling.po.orderWarning': 'Billed against customer PO {number} to date, every job’s invoices included, comes to {toDate}: {over} past its amount of {amount}.',
  'jobBilling.po.cardWarning': 'Past the customer’s PO: this job’s billable work has passed what the purchase order covers. Check with the office before more work goes unpaid.',
  'jobBilling.po.jobWarning': 'This job’s billable hours and parts to date, with what the order has already billed, come to {toDate}: {over} past customer PO {number} for {amount}. Stop and check with the office before more work goes unpaid.',
} as const;
